export const NEW_GOAL_FORM = "configNewGoalForm";
export const EDIT_GOAL_FORM = "configEditGoalForm";
export const DELETE_GOAL_FORM = "configDeleteGoalForm";